import React, { Component } from "react";
import {
  Form,
  Select,
  Input,
  message,
  Table,
  Button,
  Row,
  Col,
  Spin,
  InputNumber,
  Popconfirm,
  Modal 
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import SensorMappingStore from "../store/SensorMappingStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import { DeleteFilled } from "@ant-design/icons";
import VehicleStore from "../store/VehicleStore";

const { Column } = Table;
const { Option } = Select;

class SensorMappingAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      companyId: "",
      loadingSpin: false,
      sensor_data: [],
      sensor_mapping: [],
      selectedSensorId: undefined,
      selectedMappingId: undefined,
      tableData: [],
      multiplier: 1,
      editKey: null,
    };

    this.sensorMappingStore = new SensorMappingStore();
    this.companyStore = new CompanyStore();
    this.vehicleStore = new VehicleStore();

  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {

      this.context.viewStateStore.setVehicleGroupStates({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
        isadmin: this.props.getUserData().isadmin,
      });
     
    }

    

    const sensorMappingId = this.props.sensorMappingId;
    if (sensorMappingId) {
      await this.filldata(sensorMappingId);
      await this.setState({ sensorMappingId });
    }

    await this.vehicleStore.getDevices({"sensorMapping": true});

    await this.setState({ loadList: 1 });
    
  }

  closeModal = () => {
    this.props.closeModal();
  };

  editRecord = (record) => {

    this.setState({
        editKey: record.key,
        selectedSensorId: record.sensorId,
        selectedMappingId: record.mappingId,
        multiplier: record.multiplier,
    });

    this.formRef.current.setFieldsValue({
        sensorId: record.sensorId,
        sensorType: record.mappingId,
        multiplier: record.multiplier,
    });
  };

  async handleDeviceFields(val) {
    if (this.state.tableData.length > 0) {
      Modal.confirm({
        title: "Change Device?",
        content:
          "Changing the device will remove all sensor mappings added to the table. Do you want to continue?",
        okText: "Yes",
        cancelText: "No",

        onOk: async () => {
          
          this.setState({
            tableData: [],
            selectedDeviceId: val,
            sensor_data: [],
            sensor_mapping: [],
          }, () => {
            this.resetSensorForm();
          });

          const postData = {
            deviceId: val,
          };

          const { sensor_data, sensor_mapping } =
            await this.sensorMappingStore.sensorCodecData(postData);

          this.setState({ sensor_data, sensor_mapping });
        },

        onCancel: () => {
          this.formRef.current.setFieldsValue({
            deviceId: this.state.selectedDeviceId,
          });
        },
      });
    } else {
      this.setState({
        selectedDeviceId: val,
      });

      const postData = {
        deviceId: val,
      };

      const { sensor_data, sensor_mapping } =
        await this.sensorMappingStore.sensorCodecData(postData);

      this.setState({ sensor_data, sensor_mapping });
    }
  }

  resetSensorForm = () => {
      this.setState({
          editKey: null,
          selectedSensorId: undefined,
          selectedMappingId: undefined,
          multiplier: 1,
      });

      this.formRef.current.setFieldsValue({
          sensorId: undefined,
          sensorType: undefined,
          multiplier: 1,
      });
  };

  handleAddRecord = () => {

    const {
      selectedSensorId,
      selectedMappingId,
      multiplier,
      tableData,
      sensor_data,
      sensor_mapping,
    } = this.state;

    if (!selectedSensorId || !selectedMappingId) {
      message.error("Please select Sensor ID and Sensor Type");
      return;
    }

    const sensor = sensor_data.find(
      (item) => item.id === selectedSensorId
    );

    const mapping = sensor_mapping.find(
      (item) => item.id === selectedMappingId
    );

    const exists = tableData.some(
      item => item.sensorId === selectedSensorId
    );

    if (exists) {
      message.error("Sensor already added");
      return;
    }

    const newRecord = {
      key: Date.now(),
      sensorId: selectedSensorId,
      sensorName: sensor?.name,
      mappingId: selectedMappingId,
      mappingName: mapping?.name,
      multiplier: multiplier || 1,
    };

    this.setState({
      tableData: [...tableData, newRecord],
    }, () => {
      this.resetSensorForm();
    });

  };

  handleUpdateRecord = () => {

   

    
    const {
      editKey,
      selectedSensorId,
      selectedMappingId,
      multiplier,
      tableData,
      sensor_data,
      sensor_mapping,
    } = this.state;

    const exists = tableData.some(
      item =>
        item.sensorId === selectedSensorId &&
        item.key !== editKey
    );

    if (exists) {
      message.error("Sensor already added");
      return;
    }

    const updatedTable = tableData.map((item) => {
        if (item.key !== editKey) return item;

        return {
            ...item,
            sensorId: selectedSensorId,
            sensorName: sensor_data.find(s => s.id === selectedSensorId)?.name,
            mappingId: selectedMappingId,
            mappingName: sensor_mapping.find(m => m.id === selectedMappingId)?.name,
            multiplier,
        };
    });

    this.setState({
      tableData: updatedTable,
    }, () => {
      this.resetSensorForm();
    });

  };

  handleCancelEdit = () => {
    this.resetSensorForm();
  };

  filldata = async (sensorMappingId) => {

    await this.setState({ loadingSpin: true });

    const sensorMappingData = await this.sensorMappingStore.loadData({
      companyId: this.props.companyId,
      offset: 0,
      limit: 1,
      sensorMappingId: sensorMappingId
    });

    const deviceId = sensorMappingData.data[0].deviceId;

    const singleData = await this.companyStore.getCompanyDataById(
      this.props.companyId
    );

    await this.setState({
      companyId: sensorMappingData?.data?.companyId,
      sensorMappingId: sensorMappingData?.data[0]?.id,
      selectedDeviceId: sensorMappingData?.data[0]?.deviceId,
    });

    await this.formRef.current.setFieldsValue({
      companyId: singleData,
      templateName: sensorMappingData?.data[0]?.templateName,
      deviceId: sensorMappingData?.data[0]?.deviceId,
    });

    const { sensor_data, sensor_mapping } =
        await this.sensorMappingStore.sensorCodecData({ deviceId });
    
    await this.setState({sensor_data, sensor_mapping});    

    const tableData = sensorMappingData?.sensorMappings?.map((item, index) => {
      const sensor = this.state.sensor_data.find(
        (s) => s.id === item.sensorId
      );

      const mapping = this.state.sensor_mapping.find(
        (m) => m.id === item.mappingId
      );

      return {
        key: index,
        sensorId: item.sensorId,
        sensorName: sensor_data.find(s => s.id === item.sensorId)?.name,
        mappingId: item.mappingId,
        mappingName: sensor_mapping.find(m => m.id === item.mappingId)?.name,
        multiplier: item.multiplier,
      };
    }) || [];

    await this.setState({
      tableData
    });

    await this.setState({ loadingSpin: false });
  };

  onSensorMappingSubmit = async (values) => {

    if (!this.state.tableData.length) {
      message.error("Please add at least one sensor");
      return;
    }

    this.setState({ loading: true });

    const data = {
      templateId: this.state.sensorMappingId,
      companyId: this.state.companyId,
      deviceId: this.state.selectedDeviceId,
      templateName: values.templateName,
      createdBy: this.props.getUserData().userId,
      updatedBy: this.props.getUserData().userId,
      sensors: this.state.tableData.map(item => ({
        sensorId: item.sensorId,
        mappingId: item.mappingId,
        multiplier: item.multiplier,
      }))
    };

    const resp = await this.sensorMappingStore.addData(data);

    await this.props.response(resp);

    this.setState({ loading: false });

  };

 
  handleChange = async (comp) => {
    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleGroupId) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: comp.value,
      });
    }
  };

  render() {

    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin
            wrapperClassName="spinClass"
            spinning={this.state.loadingSpin}
            fullscreen
          >
            <Form
              style={{ maxWidth: "100%", padding: 0 }}
              layout="vertical"
              ref={this.formRef}
              onFinish={this.onSensorMappingSubmit}
              className="formClass" //change
              name="nest-message"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                      <Form.Item
                        name="companyId"
                        className="uploadCompany"
                        label={
                          <span>
                            {this.context.translate("_ACCOUNT_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: `${this.context.translate(
                              "_ACCOUNT_"
                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                          },
                        ]}
                      >
                        <CompanyAutocomplete
                          onChange={(value) => {
                            this.handleChange(value);
                          }}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    )}

                  <Form.Item
                    className="uploadCompany"
                    name="deviceId"
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_DEVICE_",
                        )} ${this.context.translate(
                          "_IS_REQUIRED_",
                        )}`,
                      },
                    ]}
                    label={
                      <span>
                        {this.context.translate("_DEVICE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                  >
                    <Select
                      onChange={(value) =>
                        this.handleDeviceFields(value)
                      }
                    >
                      {this.vehicleStore?.devices.map((val) => {
                        return (
                          <Option
                            key={val.deviceId}
                            value={val.deviceId}
                          >
                            {val.deviceName}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="multiplier"
                    label={this.context.translate("_MULTIPLIER_")}
                    initialValue={1}
                  >
                    <InputNumber
                      min={0}
                      // step={0.1}
                      style={{ width: "100%" }}
                      controls={false}
                      onChange={(value) =>
                        this.setState({ multiplier: value })
                      }
                    />
                  </Form.Item>
                </Col>

                <Col span={12} className="formColumnClass">
        
                  <Form.Item
                    name="templateName"
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_TEMPLATE_NAME_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate("_TEMPLATE_NAME_")} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="sensorId"
                    className="uploadCompany"
                    label={this.context.translate("_SENSOR_ID_")}
                  >
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      placeholder="Select Sensor"
                      value={this.state.selectedSensorId}
                      onChange={(value) =>
                        this.setState({ selectedSensorId: value })
                      }
                    >
                     {this.state.sensor_data.map((sensor) => {
                        const disabled = this.state.tableData.some(
                          (item) => item.sensorId === sensor.id
                        );

                        return (
                          <Select.Option
                            key={sensor.id}
                            value={sensor.id}
                            disabled={disabled}
                          >
                            {sensor.name} ({sensor.sensorId})
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="sensorType"
                    className="uploadCompany"
                    label={this.context.translate("_SENSOR_TYPE_")}
                  >
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      placeholder="Select Mapping"
                      value={this.state.selectedMappingId}
                      onChange={(value) =>
                        this.setState({ selectedMappingId: value })
                      }
                    >
                      {this.state.sensor_mapping.map((mapping) => {
                        const disabled = this.state.tableData.some(
                          (item) => item.mappingId === mapping.id
                        );

                        return (
                          <Select.Option
                            key={mapping.id}
                            value={mapping.id}
                            disabled={disabled}
                          >
                            {mapping.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>

                </Col>

                <Col span={24}>
                  <Row>
                    <Button
                      type="primary"
                      onClick={
                          this.state.editKey !== null && this.state.editKey !== undefined
                              ? this.handleUpdateRecord
                              : this.handleAddRecord
                      }
                      style={{ margin: "20px 0px 20px 0px" }}
                    >
                      {this.state.editKey !== null && this.state.editKey !== undefined ? this.context.translate("_UPDATE_SENSOR_") : this.context.translate("_ADD_SENSOR_")}
                    </Button>

                    {this.state.editKey !== null && this.state.editKey !== undefined && (
                      <Button
                        type="primary"
                        onClick={this.handleCancelEdit}
                        style={{ margin: "20px 0px 20px 9px" }}
                      >
                        {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                      </Button>
                    )}

                  </Row>

                  <Table 
                    dataSource={this.state.tableData} 
                    pagination={false} 
                    bordered
                    onRow={(record) => ({
                        onClick: (e) => {
                          this.editRecord(record);
                        },
                    })}
                    rowClassName={(record) =>
                      record.key === this.state.editKey ? "editing-row" : ""
                    }
                  >

                    <Column
                      title={this.context.translate("_SENSOR_ID_")}
                      dataIndex="sensorName"
                      key="sensorName"
                    />

                    <Column
                      title={this.context.translate("_SENSOR_TYPE_")}
                      dataIndex="mappingName"
                      key="mappingName"
                    />

                    <Column
                      title={this.context.translate("_MULTIPLIER_")}
                      dataIndex="multiplier"
                      key="multiplier"
                    />

                    <Column
                      title="Operation"
                      key="action"
                      render={(text, record) => (
                        <div
                          className="actionColumn"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Popconfirm
                            title={this.context.translate("_DELETE_SENSOR_MAPPING_")}
                            description={this.context.translate("_DELETE_SENSOR_MAPPING_DESC_")}
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                              this.setState({
                                tableData: this.state.tableData.filter(
                                  item => item.key !== record.key
                                ),
                              });

                              if (this.state.editKey === record.key) {
                                this.resetSensorForm();
                              }
                            }}
                          >
                            <DeleteFilled
                              style={{ color: "red", cursor: "pointer" }}
                            />
                          </Popconfirm>
                        </div>
                      )}
                    />
                  </Table>
                </Col>
              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => this.closeModal()}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  className="formsSaveButton"
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );

  }
}

SensorMappingAdd.contextType = StoreContext;
export default observer(withRouter(SensorMappingAdd));